import React, { useMemo, useState } from 'react'
import { Formik } from 'formik'
import { CircularProgress } from '@material-ui/core'
import { TextFieldIcon, SelectFieldIcon, Button, PhoneFieldIcon, TopBar, Panel } from '../_components'
import { FaPhoneAlt, FaHospitalUser, FaBuilding, FaIdBadge, FaPager, FaAddressCard, FaServer, FaThLarge, FaWindowMaximize, FaRegBuilding, FaRegWindowMaximize, FaRegListAlt, FaUserCircle, FaWarehouse, FaIdCard, FaTable, FaIndent, FaUserAlt, FaLock } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, StepperItem } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { createReferenceID } from '../_utils'

const steps = [
  "Pending", "Actioned"
]

export default function AdminUserRegistration( ) {
    const [ signing, setSigning ] = React.useState( false )
    const [ phone, setPhone ] = React.useState( "" )
    const [ roles, setRoles ] = useState( [
        { user_role: "" }
    ] )


    const handleSubmit = async( values ) => {
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/admin_itcouser`, {
                applicant: values.applicant,
                region: values.region,
                phone_number: phone,
                first_name: values.first_name,
                last_name: values.last_name,
                username: values.email_address,
                email_address: values.email_address,
                status: "REGISTERED",
                user_role: roles,
                referenceID: createReferenceID( 10 )
            }) 

            if( response.data.success === true ) {
                alert( "Registration successful. Credentials sent to user email." )
                await localStorage.setItem( "link", "dashboard" )
                return window.location.reload()
            } else{
                alert(response.data.message)
                //console.log(response.data)
            } 
        } catch (error) {
            alert( "Server error occured. Please try again later." ) 
        }
    }
    
    const [ loading, setLoading ] = useState( true )
    const [ tag, setTag ] = useState( "Pending" )

    React.useEffect( () => {
        if( loading ) {
            //fetchApplications()
        }
    },[ loading ])

    const handleInputs = ( evt, idx ) => {    
        const newRoles = [...roles];
        newRoles[idx][evt.target.name] = evt.target.value;
        setRoles(newRoles); 
    }

    const handleRemove = idx => {
        const list = [ ...roles ]
        list.splice( idx, 1 )
        return setRoles( list )
    }

    const handleAddService = () => {
        if( roles.length < 4 ) {
            return setRoles([...roles, { user_role: "" }]); // add another input to the state
        }
        
        return alert( "You can not add more than 4 role" )
    }

    return (
        <Wrapper>
            <div className="flex flex-col h-full">
                <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                    <div className= "p-12 sm:w-full w-full h-auto bg-white rounded-sm shadow-xl relative">
                        <div className="px-5 py-2 bg-white text-[#AFC836] font-bold text-lg">
                        {`Register New User`}
                        </div>
                        <div className="flex flex-col justify-center w-full bg-white">
                        
                            <Formik initialValues={{
                                applicant: "",
                                user_role: "",
                                email_address: "",
                                phone_number: "",
                            }} onSubmit={handleSubmit}>
                            { ( { handleSubmit, handleBlur, handleChange, values, isSubmitting } ) => {
                                return (
                                    <form onSubmit={handleSubmit}>
                                        <div className="w-full py-2 grid grid-cols-1 md:grid-cols-2 md:gap-2 lg:grid-cols-2 lg:gap-2">
                                            <TextFieldIcon 
                                                name="applicant"
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                value={values.applicant}
                                                iconComponent={<FaUserAlt color={`#AFC836`} />} 
                                                label="Name"
                                                required={true}
                                                disabled={signing}
                                                question="Name" />
                                            
                                            {values.category === "Other" && (
                                                <TextFieldIcon 
                                                name="other_category"
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                value={values.other_category}
                                                iconComponent={<FaUserAlt color={`#AFC836`} />} 
                                                label="Other"
                                                required={false}
                                                disabled={signing}
                                                question="Specify Other" />
                                            )}

                                            {/* <SelectFieldIcon 
                                                name="user_role"
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                value={values.user_role}
                                                iconComponent={<FaPager color={`#AFC836`} />} 
                                                label="User Role"
                                                required={true}
                                                disabled={signing}
                                                options={[
                                                { id: 1, value: "VERIFIER", label: "Verifier" },
                                                { id: 2, value: "AUDITOR", label: "Auditor" },
                                                { id: 3, value: "QA1", label: "Quality Assurance 1" },
                                                { id: 4, value: "QA2", label: "Quality Assurance 2" },
                                                { id: 4, value: "QA3", label: "Quality Assurance 3" },
                                                { id: 5, value: "APPROVER", label: "Approver" },
                                                ]}
                                                question="User Role" 
                                            /> */}

                                            <TextFieldIcon 
                                                name="email_address"
                                                type="email"
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                value={values.email_address}
                                                iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                label="Email Address"
                                                required={true}
                                                disabled={signing}
                                                question="Email Address" />

                                            <PhoneFieldIcon 
                                                name="phone_number"
                                                handleChange={handleChange}
                                                handleBlur={handleBlur}
                                                callback={ ( phone ) => {
                                                    setPhone( phone )
                                                } }
                                                question="Phone Number"
                                                required={true}
                                            />

                                            <div class="flex flex-col items-start p-5">
                                                <button onClick={() => handleAddService()} type="button" 
                                                    className="bg-purple-500 text-xs text-white p-2">
                                                    {`Add Role`}
                                                </button>
                                            </div>

                                            {roles.map( (item, idx ) => {
                                                return (
                                                    <div className="grid grid-rows-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                                                        <SelectFieldIcon 
                                                        name="user_role"
                                                        handleChange={evt => {
                                                            handleChange( evt, idx )
                                                            handleInputs( evt, idx )
                                                        }}
                                                        handleBlur={handleBlur}
                                                        value={roles[idx].user_role}
                                                        iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                        label="Roles"
                                                        required={false}
                                                        disabled={signing}
                                                        options={[
                                                            { id: 6, value: "SECURITY", label: "Security" },
                                                            { id: 1, value: "VERIFIER", label: "Verifier" },
                                                            { id: 2, value: "AUDITOR", label: "Auditor" },
                                                            { id: 3, value: "QA1", label: "Quality Assurance 1" },
                                                            { id: 4, value: "QA2", label: "Quality Assurance 2" },
                                                            { id: 4, value: "QA3", label: "Quality Assurance 3" },
                                                            { id: 5, value: "APPROVER", label: "Approver" },
                                                            ]}
                                                        question="Roles" 
                                                        />
                                            
                                                        <div className="flex items-center justify-center w-14">
                                                        {idx > 0 && ( <button onClick={() => handleRemove( idx )} type="button" 
                                                            className="bg-red-500 text-xs rounded-sm text-white px-2 py-1">
                                                            {`Remove`}
                                                        </button> ) }
                                                        </div>
                                                    </div>
                                                )
                                            })}                            
                                        </div>

                                        <div className="w-1/2 py-2 grid grid-cols-1">
                                            {signing ? (
                                            <div className="flex items-center justify-center">
                                                <CircularProgress size={24} color="primary" />
                                            </div>
                                            ):
                                            ( <Button 
                                                type="submit"
                                                loading={isSubmitting} 
                                                disabled={isSubmitting ? true : false} 
                                                label={"Submit"} /> )
                                            }
                                        </div>
                                    </form>
                                )
                            }  }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </Wrapper>
    )
}